export enum moduleTitles {
    MEDICAL = "Medical",
    LEGAL = "Legal/Financial",
    FAMILY = "Family/Social",
    SPIRITUAL = "Spiritual",
    ALL_DOMAINS = "AllDomains",
    COMING_SOON = "Coming Soon" //placeholder for tasks without content
  }

export enum howImportant {
  VERY_IMPORTANT = "Very Important",
  IMPORTANT = "Important",
  LESS_IMPORTANT = "Less Important",
  NOT_IMPORTANT = "Not Important"
}

export enum questionChoices {
  YES = "Yes, Completed",
  NO = "Not Yet",
  DNA = "Does Not Apply"
}